import { render, staticRenderFns } from "./SolicitacoesRelatoriosList.vue?vue&type=template&id=236e946c&scoped=true&"
import script from "./SolicitacoesRelatoriosList.vue?vue&type=script&lang=js&"
export * from "./SolicitacoesRelatoriosList.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacoesRelatoriosList.vue?vue&type=style&index=0&id=236e946c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236e946c",
  null
  
)

export default component.exports